<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import store from '../../store';
import Alert from '../Alert/Alert.vue';
import Loading from '../Loading/Loading.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import Instruction from '../Instruction/Instruction.vue';
import ContractForm from '../ContractForm/ContractForm.vue';
import ContractNotes from '../ContractNotes/ContractNotes.vue';
import ContractFormAlert from '../ContractFormAlert/ContractFormAlert.vue';
import ContractFormEmail from '../ContractFormEmail/ContractFormEmail.vue';
import ContractFormNotes from '../ContractFormNotes/ContractFormNotes.vue';
import ContractFormAccept from '../ContractFormAccept/ContractFormAccept.vue'
import ContractFormProgress from '../ContractFormProgress/ContractFormProgress.vue';
import ContractBreadcrumb from '../ContractBreadcrumb/ContractBreadcrumb.vue';
import ContractDraftPreview from '../ContractDraftPreview/ContractDraftPreview.vue';

export default Vue.extend({
    components: {
        Alert,
        Loading,
        InfoWidget,
        Instruction,
        ContractForm,
        ContractNotes,
        ContractFormAlert,
        ContractFormEmail,
        ContractFormNotes,
        ContractFormAccept,
        ContractFormProgress,
        ContractBreadcrumb,
        ContractDraftPreview
    },
    computed: {
        ...mapState({
            loading: state => state.contract.contract.loading,
            formLoading: state => state.contract.contract.form.loading,
            acceptLoading: state => state.contract.contract.finish.loading,
            emailLoading: state => state.contract.contractManagement.form.loading,
            draftLoading: state => state.contract.draft.loading,
            draftError: state => state.contract.draft.error,
            draft: state => state.contract.draft.item,
            user: state => state.auth.user,
            notes: state => state.contract.contract.notes.item,
            contract: state => state.contract.contract.item,
        })
    },
    beforeRouteEnter (to, from, next) {
        const supplierId = to.params.supplierId || undefined;
        const contractId = to.params.contractId || undefined;
        if (supplierId && contractId) {
            Promise.all([
                store.dispatch('contract/getContractBySupplierId', {supplierId: supplierId, contractId: contractId}),
                store.dispatch('contract/getContractNotes', {contractId: contractId}),
                store.dispatch('contract/getContractAcceptedParts', {contractId: contractId})
            ]).then(() => {
                next();
            })
        } else {
            next();
        }
    },
    beforeRouteLeave (to, from, next) {
        // If the supplier has written new messages then send notification email when leaving
        if (this.user && !this.user.contractManager && this.notes) {
            if (this.notes && this.notes[this.notes.length - 1].writtenBy === this.user.id) {
                if (confirm(this.$t('contract.form.notes.sendBeforeLeave'))) {
                    this.sendContractEmailNotification().then(() => {
                        next();
                    });
                } else {
                    next();
                }
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            sendContractEmailNotification: 'contract/sendContractEmailNotification',
            previewContractDraft: 'contract/previewContractDraft'
        }),
        previewContract() {
            if (!this.contract) {
                alert('Please reload page')
            } else {
                this.previewContractDraft({
                    supplierId: this.contract.supplierId,
                    contractId: this.contract.id
                })
            }
        },
    }
});
</script>
<template>
    <div class="contract-page">
        <div class="contract-page__content">
            <contract-breadcrumb v-if="user && user.contractManager" :contract="contract"/>
            <contract-form-alert/>
            <instruction :page="'contract'"/>
            <contract-draft-preview :loading="draftLoading"
                                    :error="draftError"
                                    :accepted="!!contract.supplierConfirm"
                                    @previewContractDraft="previewContract"/>
            <contract-form-progress/>
            <contract-form-accept/>
            <contract-form-email/>
            <contract-form/>
            <contract-notes/>
            <loading v-if="loading || formLoading || acceptLoading || emailLoading"/>
            <alert :translation-prefix="'contract.alert'"/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractPage/ContractPage.vue